var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_425",
    "data-name": "Grupo 425",
    transform: "translate(-467 -211)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_57",
    "data-name": "Elipse 57",
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    transform: "translate(467 211)",
    fill: "#f9fafc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "verified_user_black_24dp-2",
    transform: "translate(475.5 219.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_540",
    "data-name": "Trazado 540",
    d: "M0,0H44V44H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_541",
    "data-name": "Trazado 541",
    d: "M18.157,1.5,5.2,7.223A3.692,3.692,0,0,0,3,10.587v8.641c0,10.2,7.106,19.746,16.656,22.062C29.2,38.974,36.311,29.432,36.311,19.228V10.587a3.692,3.692,0,0,0-2.2-3.365L21.155,1.5a3.7,3.7,0,0,0-3,0ZM14.64,28.954,9.847,24.192a1.822,1.822,0,0,1,0-2.592,1.852,1.852,0,0,1,2.609,0l3.5,3.456L26.836,14.246a1.852,1.852,0,0,1,2.609,0,1.822,1.822,0,0,1,0,2.592L17.25,28.954a1.852,1.852,0,0,1-2.609,0Z",
    transform: "translate(2.344 0.928)",
    fill: "#37c846"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.13de8ce32c40c8a7742e959241eadf12.svg";
export { ForwardRef as ReactComponent };